import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import Form, { GroupItem, SimpleItem, Label, RequiredRule } from 'devextreme-react/form';
import { useScreenSize } from '../../../utils/media-query';
import { useAuth } from '../../../contexts/auth';
import LoaderPage from '../../../layouts/loader-page/loader-page';
import BaseFormWithBreadCrumbs from '../../../components/base-form/base-form';
import { usePublicEvents } from '../../../contexts/public-events';
import axios from "axios"
import { useDataSource } from '../../../contexts/dataSource';
import { getSelectBoxPropertiesIdText, getSelectBoxPropertiesIdName } from "../../../utils/default-props.js";


const dateEditorOptions = { displayFormat: 'dd.MM.yyyy', type: 'date' };
const timeEditorOptions = { displayFormat: 'HH:mm', type: 'time' };

function OvertimeCard() {
  const params = useParams();
  const { user } = useAuth();
  const screenSize = useScreenSize();
  const formRef = useRef();
  const id = params.id;
  const [dirty, setDirty] = useState(false)
  const { dataSourceHR } = useDataSource()



  const [formData, setFormData] = useState({
    employeeId: "",
    requestDate: new Date(),
    reason: '',
    startDate: "",
    plug: "",
    endDate: "",
    location: '',
    approvalStatus: false,
    approvalDate: undefined
  });

  useEffect(() => {
    console.log(formData)
  }, [formData])


  const [loading, setLoading] = useState(false);
 

  const employeeDataSource = useMemo(() => dataSourceHR({
    loadUrl: `/api/Employee/ComboList`,
    loadMode: "raw"
  }), [user])

  // useEffect(() => {
  //   employeeDataSource.load().then((data) => {
  //     const options = data.map(emp => ({
  //       employeeName: emp.name,
  //       employeeId: emp.id
  //     }));
  //     setEmployeeOptions(options);
  //   });
  // }, [employeeDataSource]);

  const handleChange = (e) => {
    setDirty(true);

    // if (e.dataField === "employeeName") {
    //   setFormData(prev => ({
    //     ...prev,
    //     employeeId: e.value
    //   }));
    // }
  };

  const employeEditorOptions = {
    dataSource: employeeDataSource,
    ...getSelectBoxPropertiesIdText
  }



  return (
    <LoaderPage loading={loading}>
      <div className="content-block">
        <div className="dx-card responsive-paddings">
          <BaseFormWithBreadCrumbs
            formData={formData}
            setFormData={setFormData}
            formRef={formRef}
            loadId={id}
            loadUrl="api/EmployeeOvertime"
            updateUrl="api/EmployeeOvertime/FormData"
            dataLoading={loading}
            setDataLoading={setLoading}
            dirty={dirty}
          >
            <Form
              formData={formData}
              labelLocation={screenSize.isXSmall ? "top" : "left"}
              ref={formRef}
              width={650}
              onFieldDataChanged={(e) => handleChange(e)}

            >
              <GroupItem caption="Fazla Mesai Talebi Oluşturma">

                <SimpleItem
                  dataField="employeeId"
                  editorType="dxSelectBox"
                  editorOptions={employeEditorOptions}>
                  <Label text="Personel" />
                  <RequiredRule />
                </SimpleItem>

                <SimpleItem dataField="plug" editorType="dxTextBox">
                  <Label text="Fiş" />
                  <RequiredRule message="Bu alan zorunludur" />
                </SimpleItem>
                <SimpleItem dataField="reason" editorType="dxTextArea" editorOptions={{ height: 60 }}>
                  <Label text="F. Mesainin Gerekçesi" />
                  <RequiredRule message="Bu alan zorunludur" />
                </SimpleItem>
                <SimpleItem dataField="requestDate" editorType="dxDateBox" editorOptions={dateEditorOptions}>
                  <Label text="İstek Tarihi" />
                </SimpleItem>
                <GroupItem colCount={2}>

                  <SimpleItem dataField="startDate" editorType="dxDateBox" editorOptions={dateEditorOptions}>
                    <Label text="Başlama Tarihi" />
                  </SimpleItem>
                  {
                    // <SimpleItem dataField="startTime" editorType="dxDateBox" editorOptions={timeEditorOptions}>
                    //   <Label text="Saat" />
                    // </SimpleItem>
                  }

                </GroupItem>
                <GroupItem colCount={2}>
                  <SimpleItem dataField="endDate" editorType="dxDateBox" editorOptions={dateEditorOptions}>
                    <Label text="Bitiş Tarihi" />
                  </SimpleItem>
                  {
                    // <SimpleItem dataField="endTime" editorType="dxDateBox" editorOptions={timeEditorOptions}>
                    //   <Label text="Saat" />
                    // </SimpleItem>
                  }

                </GroupItem>
                <SimpleItem dataField="location" editorType="dxTextBox">
                  <Label text="Konum" />
                  <RequiredRule message="Bu alan zorunludur" />
                </SimpleItem>
                {
                  // <SimpleItem dataField="attachmentFile" editorType="dxFileUploader" editorOptions={{ selectButtonText: "Dosya Seç", labelText: "veya Dosyayı Buraya Sürükleyin", uploadMode: "useForm" }}>
                  //   <Label text="Belge Ekle" />
                  // </SimpleItem>
                }


              </GroupItem>
            </Form>
          </BaseFormWithBreadCrumbs>
        </div>
      </div>
    </LoaderPage>
  );
}

export default OvertimeCard;